(self["webpackChunkspurtdigital"] = self["webpackChunkspurtdigital"] || []).push([["/app"],{

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bootstrap/js/dist/modal */ "./node_modules/bootstrap/js/dist/modal.js");
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var bootstrap_js_dist_dropdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! bootstrap/js/dist/dropdown */ "./node_modules/bootstrap/js/dist/dropdown.js");
/* harmony import */ var bootstrap_js_dist_dropdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_dropdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var bootstrap_js_dist_collapse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! bootstrap/js/dist/collapse */ "./node_modules/bootstrap/js/dist/collapse.js");
/* harmony import */ var bootstrap_js_dist_collapse__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_collapse__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! bootstrap/js/dist/tab */ "./node_modules/bootstrap/js/dist/tab.js");
/* harmony import */ var bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./toggles */ "./src/js/toggles.js");
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_toggles__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");






window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
var mq = {
  xxs: 0,
  xs: 380,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxxxl: 1800
};
function replaceMenu() {
  if ($(window).width() < mq.xl) {
    $('.js-panel nav').append($('.js-nav-main'));
    $('.js-panel').append($('.js-header-actions'));
    $('.js-panel').append($('.js-nav-bar-top-links'));
    $('.js-filter-panel').append($('.js-collection-filters'));
  } else {
    $('.js-main-nav').append($('.js-nav-main'));
    $('.js-navbar-top').append($('.js-nav-bar-top-links'));
    $('.js-header-right ').append($('.js-nav-main'));
    $('.js-sidebar-filters').append($('.js-collection-filters'));
  }
}
replaceMenu();
$(window).on('resize', function () {
  replaceMenu();
});
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.navbar');
  function checkScroll() {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  // Check meteen bij laden
  checkScroll();

  // Luister naar scroll
  window.addEventListener('scroll', checkScroll);
});

/**
 * FAQ toggle
 **/

$(document).on('click', '.js-faq-toggle', function (e) {
  e.preventDefault();
  $(this).toggleClass('is-active');
  var parent = $(this).closest('.js-faq');
  if (parent.hasClass('is-active')) {
    parent.removeClass('is-active').find('.js-faq-content').stop().slideUp(300);
  } else {
    parent.addClass('is-active').find('.js-faq-content').stop().slideDown(300);
  }
});
$('.footer-toggle').on('click', function () {
  // alleen mobiel
  if (window.matchMedia('(min-width: 768px)').matches) return;
  var $toggle = $(this);
  var $menu = $toggle.next('.footer__menu');

  // toggle menu
  $menu.slideToggle(200);
  $toggle.toggleClass('is-open');
});

// Standaard dicht

// Alles dichtzetten
$('.product-tabs__content').hide();

// Eerste tab open en actief
$('.js-product-tabs').first().addClass('is-active').next('.product-tabs__content').show();
$('.js-product-tabs').on('click', function () {
  $(this).toggleClass('is-active').next('.product-tabs__content').stop(true, true).slideToggle();
});
document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.delivery-estimate');
  if (!el) return;
  var cutoffHour = parseInt(el.dataset.cutoffHour || '23', 10); // bijv. 23
  var leadDays = parseInt(el.dataset.leadDays || '1', 10); // bijv. 1

  // Rekenen in Europe/Amsterdam (voorkomt rare tijdzone-afwijkingen)
  var now = new Date();
  var amsNow = new Date(now.toLocaleString('en-US', {
    timeZone: 'Europe/Amsterdam'
  }));
  var shipDate = new Date(amsNow);
  if (amsNow.getHours() >= cutoffHour) {
    shipDate.setDate(shipDate.getDate() + 1); // na cut-off: +1 dag
  }
  shipDate.setDate(shipDate.getDate() + leadDays); // levertijd erbij

  var cutoffStr = String(cutoffHour).padStart(2, '0') + ':00';
  var dateStr = shipDate.toLocaleDateString('nl-NL', {
    day: '2-digit',
    month: 'long'
  });
  var target = el.querySelector('.delivery-text');
  if (target) target.textContent = "Bestel voor ".concat(cutoffStr, ", geleverd op ").concat(dateStr);
});
$('.js-nav-top-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  autoplay: true,
  autoplaySpeed: 1200,
  speed: 500
});
$(document).ready(function () {
  var $container = $('.footer__infinty');

  // 1. Haal de originele content op
  var originalContent = $container.html();

  // 2. Maak een wrapper, en stop de content er 2x in
  //    De tweede keer is nodig om de loop naadloos te maken
  var newStructure = '<div class="infinity-scroll-wrapper">' + originalContent + originalContent + '</div>';

  // 3. Vervang de HTML in de container
  $container.html(newStructure);
});

/***/ }),

/***/ "./src/js/sliders.js":
/*!***************************!*\
  !*** ./src/js/sliders.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-slider */ "./node_modules/slick-slider/slick/slick.js");
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_slider__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");

var mq = {
  xxs: 0,
  xs: 380,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxxxl: 1800
};
$(document).ready(function () {
  var $heroSlider = $('.js-product-hero-slider');
  var $thumbsSlider = $('.js-product-hero-thumbs');

  // Check of beide elementen bestaan
  if ($heroSlider.length && $thumbsSlider.length) {
    var slideCount = $thumbsSlider.children().length;

    // Bepaal slidesToShow op basis van aantal slides
    var slidesToShow = Math.min(slideCount, 5);
    var useCenterMode = slideCount > 1;

    // Eerst de thumbs slider initialiseren (zonder asNavFor)
    $thumbsSlider.slick({
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      centerMode: useCenterMode,
      centerPadding: '0px',
      focusOnSelect: true,
      infinite: slideCount > 1,
      variableWidth: false,
      responsive: [{
        breakpoint: mq.lg,
        settings: {
          slidesToShow: Math.min(slideCount, 4),
          centerMode: slideCount > 1
        }
      }, {
        breakpoint: mq.md,
        settings: {
          slidesToShow: Math.min(slideCount, 3),
          centerMode: slideCount > 1
        }
      }]
    });

    // Dan de hoofdslider met asNavFor naar thumbs
    $heroSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: $thumbsSlider
    });

    // Nu de thumbs koppelen aan de hero slider
    $thumbsSlider.slick('slickSetOption', 'asNavFor', $heroSlider, true);
  }

  // Variatie selectie om naar de juiste afbeelding te sliden
  $('#variant-select').on('change', function () {
    // Haal de index op van de geselecteerde variatie
    var selectedIndex = $(this).find(':selected').data('variant-index');

    // Schakel de hoofdafbeelding naar de corresponderende slide
    $('.js-product-hero-slider').slick('slickGoTo', selectedIndex);
  });
});

// 07-10-2026 (punt 3 mail Leonard): productsliders op mobiel als native veegbalk.
// Onder 768px draait Slick niet; de kaarten staan dan in een horizontale
// scrollbalk met scroll-snap (assets/bamboosa-fixes-0710.css blok 8). Vanaf 768px
// wordt Slick gestart met dezelfde instellingen als voorheen (4/5 kaarten, onder
// 992px 3). bbInitSliders schakelt bij het passeren van 768px (draaien van
// telefoon/tablet, venster verkleinen) Slick in of uit.
var bbSliders = [['.js-bestsellers-slider', {
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  focusOnSelect: true,
  infinite: false,
  arrows: false,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 3
    }
  }]
}], ['.js-review-slider', {
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  focusOnSelect: true,
  infinite: false,
  arrows: false,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 3
    }
  }]
}], ['.js-blog-slider', {
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  focusOnSelect: true,
  infinite: false,
  arrows: false,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 3
    }
  }]
}]];
function bbInitSliders() {
  // Zelfde voorwaarde als de CSS van de veegbalk (max-width: 767.98px), zodat
  // script en opmaak altijd tegelijk wisselen (ook met een scrollbalk in beeld).
  var mobiel = window.matchMedia ? window.matchMedia('(max-width: 767.98px)').matches : $(window).width() < mq.md;
  bbSliders.forEach(function (item) {
    var $el = $(item[0]);
    if (mobiel) {
      $el.filter('.slick-initialized').slick('unslick');
    } else {
      $el.not('.slick-initialized').slick($.extend(true, {}, item[1]));
    }
  });
}
bbInitSliders();
var bbSliderTimer;
$(window).on('resize orientationchange', function () {
  clearTimeout(bbSliderTimer);
  bbSliderTimer = setTimeout(bbInitSliders, 150);
});
// Reageert precies op het passeren van 768px, ook als er geen resize-event komt.
if (window.matchMedia) {
  var bbMq = window.matchMedia('(max-width: 767.98px)');
  var bbOnMq = function () {
    clearTimeout(bbSliderTimer);
    bbSliderTimer = setTimeout(bbInitSliders, 50);
  };
  if (bbMq.addEventListener) bbMq.addEventListener('change', bbOnMq);
  else if (bbMq.addListener) bbMq.addListener(bbOnMq);
}

/***/ }),

/***/ "./src/js/toggles.js":
/*!***************************!*\
  !*** ./src/js/toggles.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
// 07-10-2026 (punt 13): de knop is nu een <button>; aria-expanded en het label volgen
// de stand van het menu, Escape sluit het menu.
function bbSetNav(open) {
  $(".js-nav-toggle").toggleClass("is-active", open).attr("aria-expanded", open ? "true" : "false").attr("aria-label", open ? "Menu sluiten" : "Menu openen");
  $("html").toggleClass("show-nav", open);
}
$(document).on("click", ".js-nav-toggle", function (e) {
  e.preventDefault();
  bbSetNav(!$("html").hasClass("show-nav"));
});
$(document).on("keydown", function (e) {
  if (e.key === "Escape" && $("html").hasClass("show-nav")) {
    bbSetNav(false);
    $(".js-nav-toggle").first().trigger("focus");
  }
});

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["app","/vendor"], () => (__webpack_exec__("./src/js/app.js"), __webpack_exec__("./src/scss/app.scss")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);